<i18n
  src="@/locales/views/customer/query/containers_intermediated/list_containers.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/exportation.yml" lang="yaml"></i18n>

<template>
  <go-back-link
    :text="$t('labels.go-back-link')"
    :name="routeName('')"
    :params="{
      customer_id: customer_id
    }"
  />

  <bread-crumbs
    :labels="[module_name, agro_exporter_process?.name]"
  ></bread-crumbs>

  <template v-if="load_data_general">
    <div class="flex flex-row justify-start">
      <div class="panel-plain-label">
        <badge-default
          :label="containers.total + ' ' + $t('labels.total_number_containers')"
        />
        <span class="space-actions" />
        <exportation-status
          :status_id="0"
          :prepend_label="' ' + containers.in_preparation"
        />
        <span class="space-actions" />
        <exportation-status
          :status_id="1"
          :prepend_label="' ' + containers.in_transit"
        />
        <span class="space-actions" />
        <exportation-status
          :status_id="2"
          :prepend_label="' ' + containers.arrived"
        />
      </div>
    </div>
    <div class="flex flex-row-reverse mt-4 gap-2">
      <white-button
        v-if="filtered"
        :label="$t('labels.clear_button')"
        @click.prevent="clearFilters"
      />
      <white-button
        :label="$t('labels.filter_button')"
        @click.prevent="filterContainers"
      />

      <input
        v-for="container_attribute in agro_exporter_process?.container_attributes ||
        []"
        :key="container_attribute.id"
        type="text"
        v-model.trim="filters.container_attributes[container_attribute.id]"
        :placeholder="container_attribute.name"
        class="shadow-sm focus:ring-[#5c7a2e] focus:border-[#5c7a2e] block sm:text-sm border-slate-300 rounded-md"
      />
      <input
        type="text"
        v-model.trim="filters.container_code"
        :placeholder="$t('model.container.container_code')"
        class="shadow-sm focus:ring-[#5c7a2e] focus:border-[#5c7a2e] block sm:text-sm border-slate-300 rounded-md"
      />
      <input
        type="text"
        v-model.trim="filters.week"
        :placeholder="$t('model.container.week')"
        class="shadow-sm focus:ring-[#5c7a2e] focus:border-[#5c7a2e] block sm:text-sm border-slate-300 rounded-md"
      />
    </div>
    <div class="mt-8 flex flex-col">
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.exportation.week") }}
                  </th>

                  <th scope="col" class="table-header-cell">
                    {{ $t("model.exportation.container") }}
                  </th>

                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.provider") }}
                  </th>

                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.packing_house") }}
                  </th>

                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.crop") }}
                  </th>

                  <th
                    v-for="container_attribute in agro_exporter_process.container_attributes"
                    :key="container_attribute.id"
                    scope="col"
                    class="table-header-cell"
                  >
                    {{ container_attribute.name }}
                  </th>

                  <th scope="col" class="table-header-cell">
                    {{ $t("model.exportation.booking_code_0") }}
                  </th>

                  <th scope="col" class="table-header-cell"></th>

                  <th scope="col" class="table-header-cell">
                    {{ $t("model.exportation.status") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.exportation.departured_at") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.exportation.origin_export") }}
                  </th>

                  <th scope="col" class="table-header-cell">
                    {{ $t("model.exportation.destination_export") }}
                  </th>

                  <th scope="col" class="table-header-cell"></th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  class="table-row"
                  v-for="container in containers.records"
                  :key="container.id"
                >
                  <td class="table-cell">{{ container.exportation?.week ?? container.week }}</td>


                  <td
                    class="table-cell-main link"
                    @click.prevent="goToShow(container)"
                  >
                    {{ container.container_code }}
                  </td>

                  <td class="table-cell">
                    <li>
                      <ol
                        v-for="provider in container.provider_names"
                        :key="provider"
                      >
                        {{
                          provider
                        }}
                      </ol>
                    </li>
                  </td>

                  <td class="table-cell">
                    <li>
                      <ol
                        v-for="packing_house in container.packing_house_names"
                        :key="packing_house"
                      >
                        {{
                          packing_house
                        }}
                      </ol>
                    </li>
                  </td>

                  <td class="table-cell">
                    {{ container.crop.name }}
                  </td>

                  <td
                    v-for="container_attribute in agro_exporter_process.container_attributes"
                    :key="container_attribute.id"
                    class="table-cell"
                  >
                    {{
                      containerAttributeValue(container, container_attribute)
                    }}
                  </td>

                  <td
                    class="table-cell-main link"
                    @click.prevent="goToShow(container)"
                  >
                    {{ container.exportation?.booking_code }}
                  </td>
                  <td class="table-cell">
                    <exportation-type
                      v-if="container.exportation != null"
                      :exportation_type_id="
                        container.exportation.exportation_type_id
                      "
                      :only_icon="true"
                    />
                  </td>
                  <td class="table-cell">
                    <exportation-status
                      :status_id="container.exportation?.status_id"
                    />
                  </td>
                  <td class="table-cell">
                    {{ dateFormatter(container.exportation?.departured_at) }}
                  </td>

                  <td class="table-cell">
                    {{ container.exportation?.origin_export?.name }}
                  </td>

                  <td class="table-cell">
                    {{ container.exportation?.destination_export?.name }}
                  </td>

                  <td class="table-cell-action">
                    <a class="link" @click.prevent="goToShow(container)">
                      <i class="fa-solid fa-eye"></i>
                      <span class="space-icon"></span>
                      {{ $t("labels.show_link") }}
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- v-if="load_total" -->
    <table-paginator
      v-if="!loading_containers"
      v-model="current_page"
      :total_rows="containers.total"
      :rows_per_page="rows_per_page"
    />
  </template>
  <template v-else>
    <loading-message />
  </template>
</template>

<script>
import Requester from "@/views/customer/requesters/query/containers_intermediated/list_containers.js";
import ExportationStatus from "@/components/views/agro_exporter/production/shared/exportation/ExportationStatus.vue";
import ExportationType from "@/components/views/agro_exporter/production/shared/exportation/ExportationType.vue";
import TablePaginator from "@/components/views/layout/TablePaginator.vue";

export default {
  name: "CustomerQueryContainersIntermediatedListContainers",
  components: {
    ExportationStatus,
    ExportationType,
    TablePaginator
  },
  props: {
    customer_id: { required: true },
    agro_exporter_process_id: { required: true }
  },
  data: function () {
    return {
      containers: {},
      agro_exporter_process: null,
      load_data_general: false,
      loading_containers: false,
      current_page: 1,
      rows_per_page: 12,
      filtering: false,
      filtered: false,
      filters: {
        container_code: "",
        week: "",
        container_attributes: {}
      }
    };
  },
  methods: {
    fetchAgroExporterProcess: async function () {
      const response = await Requester.fetchAgroExporterProcess(
        this.customer_id,
        this.agro_exporter_process_id
      );
      this.agro_exporter_process = response.data;
    },
    fetchContainers: async function () {
      this.loading_containers = true;
      const response = await Requester.fetchContainers(
        this.customer_id,
        this.agro_exporter_process_id,
        {
          current_page: this.current_page,
          rows_per_page: this.rows_per_page,
          ...this.filters
        }
      );
      this.containers = response.data;
      this.loading_containers = false;
      this.load_data_general = true;
    },
    filterContainers: function () {
      this.filtering = true;
      if (this.current_page == 1) {
        this.fetchContainers();
      }
      this.current_page = 1;
      this.filtered = true;
      this.filtering = false;
    },

    containerAttributeValue: function (container, container_attribute) {
      return container.container_attribute_values.find(
        value =>
          value.exporter_process_container_attribute_id ===
          container_attribute.id
      )?.value;
    },

    goToShow: function (container) {
      this.$router.push({
        name: this.routeName("show_container"),
        params: {
          customer_id: this.customer_id,
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: container.id
        }
      });
    },

    clearFilters: function () {
      this.filtered = false;
      this.filters = {
        container_code: "",
        week: "",
        container_attributes: {}
      };
      if (this.current_page == 1) {
        this.fetchContainers();
      }
      this.current_page = 1;
    }
  },
  watch: {
    current_page: function () {
      this.fetchContainers();
    }
  },
  created: function () {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          customer_id: this.customer_id
        }
      }).then(() => {
        this.fetchAgroExporterProcess();
        this.fetchContainers();
      })
    );
  }
};
</script>
